import { createFileRoute, useLocation } from '@tanstack/react-router'
import { isHelpCentrePageSlug } from '~/components/nav-help-centre'

export const Route = createFileRoute('/help-centre/$')({
	component: HelpCentrePage,
})

function HelpCentrePage() {
	const { _splat } = Route.useParams()
	const location = useLocation()
	const requestedPage = _splat || 'spark-ai'
	const page = isHelpCentrePageSlug(requestedPage) ? requestedPage : 'spark-ai'
	const hashFragment = location.hash ? `#${location.hash}` : ''

	return (
		<div className="flex h-full flex-1 flex-col">
			<iframe
				src={`/help-centre/${page}.html${hashFragment}`}
				className="h-full w-full flex-1 border-0"
				title="Help Centre"
			/>
		</div>
	)
}
